module.exports = __webpack_public_path__ + "img/back-arrow.b407062b.svg";